module.exports = __webpack_public_path__ + "img/constantcontact-logo.cd33ce5b.png";